import { PlatformLocation } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { AbstractContentComponent } from '@epicuro-next/elements/content-core';
import { PulseContentElement } from '@epicuro-next/elements/core';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';

const selector = 'pcn-link';
@PulseContentElement({ selector })
@Component({
  selector,
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkComponent
  extends AbstractContentComponent
  implements OnInit, OnDestroy
{
  @Input()
  public href: string;

  @Input()
  public newTab = false;

  constructor(
    cdr: ChangeDetectorRef,
    elementRef: ElementRef,
    zone: NgZone,
    private router: Router,
    private location: PlatformLocation,
  ) {
    super(cdr, elementRef, zone);
  }

  public ngOnInit() {
    super.ngOnInit();
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
  }

  public get link() {
    if (this.href.startsWith('http')) return this.href;

    const parts = this.router.url.split(APP_PRIVATE_PATHS.content.path);
    const sitesStr = parts[0];
    const base = this.location.getBaseHrefFromDOM();
    const link = `${base}/${sitesStr}${this.href}`;

    return link.replace(/\/\/+/g, '/');
  }
}
